var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.text
    ? _c(
        "el-tooltip",
        {
          attrs: {
            effect: "dark",
            content: _vm.text,
            placement: _vm.posicaoTooltip
          }
        },
        [
          _c(
            "span",
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  style: _vm.getColor + _vm.getFont,
                  attrs: {
                    type: _vm.tipo,
                    disabled: _vm.disabled,
                    size: "mini"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("click")
                    }
                  },
                  nativeOn: {
                    mouseover: function($event) {
                      return _vm.hover($event)
                    },
                    mouseout: function($event) {
                      return _vm.leave($event)
                    }
                  }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: _vm.icone } }),
                  _vm.innerText
                    ? _c("span", { staticClass: "center" }, [
                        _c("b", [_vm._v("  " + _vm._s(_vm.innerText))])
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d0b7349", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0b7349","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppActionButton.vue
// module id = null
// module chunks = 